import React from 'react'

class Img extends React.Component {
  render () {
    const { url } = this.props
    return (
      <div>
        <section>
          <div
            className="i2-img-wrap"
            style={{ maxWidth: '100%', textAlign: 'center' }}
          >
            <img
              src={url}
              alt=""
              style={{
                maxWidth: '100%',
                height: 'auto',
                verticalAlign: 'middle',
                display: 'inline-block'
              }}
            />
          </div>
        </section>
      </div>
    )
  }
}

export default Img
